'use client';

import type { DesktopSignInRequest } from '@/lib/auth/desktop-return';

export function desktopBrowserSignInBridge() {
  if (typeof window === 'undefined' || !('imaiDesktop' in window)) return null;
  const bridge = window.imaiDesktop;
  if (
    !bridge ||
    typeof bridge !== 'object' ||
    !('version' in bridge) ||
    bridge.version !== 1 ||
    !('beginBrowserSignIn' in bridge) ||
    typeof bridge.beginBrowserSignIn !== 'function'
  )
    return null;
  // Copy the narrow method so arbitrary properties cannot enter auth callers.
  const begin = bridge.beginBrowserSignIn;
  return {
    beginBrowserSignIn: async (request: DesktopSignInRequest) => {
      await begin(request);
    },
  };
}
